import type { ReactNode } from 'react';

export const symbol_transit_enterexit: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M409-335h185q19.58 0 33.29 13.71T641-288q0 20-13.71 34T594-240H270q-12.75 0-21.37-8.63Q240-257.25 240-270v-324q0-19.58 14-33.29T288-641q20 0 33.5 13.71T335-594v185l275-275q15.17-15 37.09-15Q669-699 684-683.86q15 15.13 15 37Q699-625 684-610L409-335Z"
		/>
	</svg>
);
